import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/svg/pricing-img-lg.svg'


const _hoisted_1 = { class: "col-lg-6 col-md-3 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = {
  style: {"margin-bottom":"5px"},
  id: "bwtotal"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Residential proxies ")
const _hoisted_7 = {
  class: "pricing-amount",
  style: {"padding-top":"0"}
}
const _hoisted_8 = { class: "monthly_price" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "$")
], -1)
const _hoisted_10 = {
  class: "price",
  id: "bwprice"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", { style: {"text-align":"left"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "7+ million residential pool."),
  /*#__PURE__*/_createElementVNode("li", null, "$4.6 per GB."),
  /*#__PURE__*/_createElementVNode("li", null, "HTTP and HTTPs proxies."),
  /*#__PURE__*/_createElementVNode("li", null, "User:pass proxy authentication")
], -1)
const _hoisted_12 = { class: "pricing-content" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Purchase")



// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  props: {
  card: Object,
},
  setup(__props) {

const { card } = __props



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h2", _hoisted_4, [
        _createTextVNode(_toDisplayString(__props.card.name) + "GB bandwidth", 1),
        _hoisted_5,
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, _toDisplayString(__props.card.price), 1)
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, {
          class: "pricing-btn blue-btn",
          to: `/purchase?type=beta_new_residential&bandwidth=${__props.card.name}`
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})